"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VirtualizedListItems = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const classnames_1 = __importDefault(require("classnames"));
const ListItem_1 = __importDefault(require("../../../components/ListItem/ListItem"));
const ListTitle_1 = __importDefault(require("../../ListTitle/ListTitle"));
const VirtualizedList_1 = __importDefault(require("../../../components/VirtualizedList/VirtualizedList"));
const VirtualizedListItems_module_scss_1 = __importDefault(require("./VirtualizedListItems.module.scss"));
const ITEM_CHILDREN_TYPES = {
    TITLE: "title",
    ITEM: "item"
};
const LIST_TITLE_HEIGHT = 48;
const LIST_ITEM_HEIGHT = 32;
const VirtualizedListItems = ({ children }) => {
    const items = (0, react_1.useMemo)(() => {
        const childrenArr = Array.isArray(children) ? children : [children];
        return childrenArr
            .map((child, index) => {
            // @ts-ignore displayName is coming from Component assigned field: ListTitle, ListItem
            const childTypeDisplayName = child.type.displayName;
            if (childTypeDisplayName === ListTitle_1.default.displayName) {
                return {
                    type: ITEM_CHILDREN_TYPES.TITLE,
                    id: `list-title-${index}`,
                    props: child.props,
                    // avoid add spacing to the first category on the list
                    height: LIST_TITLE_HEIGHT
                };
            }
            else if (childTypeDisplayName === ListItem_1.default.displayName) {
                const { id } = child.props;
                return {
                    type: ITEM_CHILDREN_TYPES.ITEM,
                    id: id || `list-item-${index}`,
                    props: child.props,
                    height: LIST_ITEM_HEIGHT
                };
            }
            else {
                return undefined;
            }
        })
            .filter(item => item !== undefined);
    }, [children]);
    const itemRenderer = (0, react_1.useCallback)((item, index, style) => {
        const { type, props } = item;
        let element;
        switch (type) {
            case ITEM_CHILDREN_TYPES.TITLE: {
                element = (0, jsx_runtime_1.jsx)(ListTitle_1.default, Object.assign({}, props));
                break;
            }
            case ITEM_CHILDREN_TYPES.ITEM: {
                element = (0, jsx_runtime_1.jsx)(ListItem_1.default, Object.assign({}, props));
                break;
            }
        }
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "monday-style-list_virtualized-list-element", style: style }, { children: element })));
    }, []);
    return (
    // @ts-ignore TODO TS-migration fix when VirtualizedList is converted to TS
    (0, jsx_runtime_1.jsx)(VirtualizedList_1.default, { scrollableClassName: (0, classnames_1.default)(VirtualizedListItems_module_scss_1.default.scrollableContainer), items: items, itemRenderer: itemRenderer }));
};
exports.VirtualizedListItems = VirtualizedListItems;
